import { styled } from 'stitches.config'
import { Text } from 'components/Text'
export const IsRawSafeRoot = styled('div', {
    width: '100%',
    background: '$accent-white',
    color: '$accent-black',
    maxWidth: '500px',
    margin: 'auto',
    padding: '$6 0 $4 0',

    '@bp2': {
      maxWidth: '1280px',
      padding: '$9 0',
    }
})

export const Header = styled(Text, {
    width: '100%',
    margin: 'auto',
    marginBottom: '$3',
    '@bp2': {
      marginBottom: '$4',
    }
})

export const IsRawSafeBox = styled('div', {
    display: 'flex',
    gap: '0',
    flexDirection: 'column',
    
    '@bp2': {
      gap: '$3'
    },

    '@bp3': {
      gap: '$8'
    }
  });
  
  export const IsRawSafeColumn = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '&:last-child': {
      flexDirection: 'column-reverse',
    },

    '@bp2': {
      flexDirection: 'row',

      '&:last-child': {
        flexDirection: 'row',
      },
    },
  });
  
  export const ImageWrapper = styled('div', {
    width: '100%',
    maxWidth: '633px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
   height: '100%',

    '@bp3': {
      height: '438px',
    }
  });

  export const Description = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    gap: '$3',
    width: '100%',
    margin: 'auto',
    maxWidth: '500px',
    padding: '$3 $2',
    '@bp3': {
      padding: '40px',
      maxWidth: '580px',
    }
  });

  export const Span = styled('span', {
    fontWeight: '$bold',
  })

  export const ButtonWrapper = styled('div', {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '$3',
    '@bp2': {
      marginTop: '$8',
    }
  })